document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mega-menu__slider-wrapper').forEach((wrapper) => {
    const list = wrapper.querySelector('.mega-menu__list--collections');
    const prevBtn = wrapper.querySelector('.mega-menu__slider-btn--prev');
    const nextBtn = wrapper.querySelector('.mega-menu__slider-btn--next');

    if (!list || (!prevBtn && !nextBtn)) return;

    const getCardWidth = () => {
      const slide = list.querySelector('.mega-menu__slide');
      if (!slide) return 0;
      const gap = parseFloat(getComputedStyle(list).gap) || 16;
      return slide.offsetWidth + gap;
    };

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        list.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        list.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
      });
    }
  });
});
